import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const productsJswStorageManagementRoute: InvariantJiraRoute = {
	name: 'products-jsw-storage-management',
	path: '/jira/settings/products/jira-software-configuration/storage-management',
	exact: true,
};
